import Vue, { PropType } from 'vue';
import OS from 'framework/utils/OS';
import { IMonthListItem } from 'js/crossword/getYearsInfo';
import { Provider } from "js/crossword/types";

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  data() {
    return {
      desktop: OS.desktop,
    };
  },
  props: {
    availableMonths: Array as PropType<IMonthListItem[]>,
    currentMonthIndex: Number,
  },
  computed: {
    currentMonth(): IMonthListItem {
      return this.availableMonths[this.currentMonthIndex];
    },
  },
  render() {
    return (
      <div class='calendarMonthPicker'>
        <div class='calendarMonthPicker__arrowWrapper' onClick={() => this.$emit("monthIndexChange", -1)}>
          <img src='images/Arrow_Grey.svg' class='calendarMonthPicker__arrow calendarMonthPicker__arrow--left'/>
        </div>
        <div class={{
          "calendarMonthPicker__labelContainer": true,
          "calendarMonthPicker__labelContainer--mobile": !OS.desktop,
        }}>
          <span class='calendarMonthPicker__monthLabel'>
            { this.localization.getMonthName(this.currentMonth.month) }&nbsp;
          </span>
          <span>{ this.currentMonth.year }</span>
        </div>
        <div class='calendarMonthPicker__arrowWrapper' onClick={() => this.$emit("monthIndexChange", 1)}>
          <img src='images/Arrow_Grey.svg'  class='calendarMonthPicker__arrow calendarMonthPicker__arrow--right'/>
        </div>
      </div>
    );
  },
});
